import { render, staticRenderFns } from "./ContentEditImage.vue?vue&type=template&id=96acb3f8&"
import script from "./ContentEditImage.vue?vue&type=script&lang=js&"
export * from "./ContentEditImage.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
